<template>
  <div class="chrome-gps">
    <div class="modal chrome-gps-modal">
      <div class="modal-background" @click="closeModal" />
      <button class="modal-close is-large" @click="closeModal" />
      <div class="modal-card">
        <section class="modal-card-body">
          <p class="header">
            {{ $t("gps.chrome-title") }}
          </p>

          <!-- Step 1 -->
          <p class="text">
            {{ $t("gps.chrome-step-1") }}
          </p>
          <p class="img-wrapper">
            <img
              src="../assets/chrome_icon.png"
              style="height: 80px; border-radius: 20%"
              @click="openChromeBrowser"
            />
          </p>

          <!-- Step 2 -->
          <p class="text">
            {{ $t("gps.chrome-step-2") }}
          </p>
          <p class="img-wrapper">
            <img :src="$t('gps.chrome-img-1')" />
          </p>

          <!-- Step 3 -->
          <p class="text">
            {{ $t("gps.chrome-step-3") }}
          </p>
          <p class="img-wrapper">
            <img :src="$t('gps.chrome-img-2')" />
          </p>

          <!-- Step 4 -->
          <p class="text">
            {{ $t("gps.chrome-step-4") }}
          </p>
          <p class="img-wrapper">
            <img :src="$t('gps.chrome-img-3')" />
          </p>

          <!-- Step 5 -->
          <p class="text">
            {{ $t("gps.chrome-step-5") }}
          </p>
          <p class="img-wrapper">
            <img :src="$t('gps.chrome-img-4')" />
          </p>

          <!-- Step 6 -->
          <p class="text">
            {{ $t("gps.chrome-step-6") }}
          </p>
          <p class="img-wrapper">
            <img :src="$t('gps.chrome-img-5')" />
          </p>

          <!-- Step 7 -->
          <p class="text">
            {{ $t("gps.chrome-step-7") }}
          </p>
          <p class="img-wrapper">
            <img :src="$t('gps.chrome-img-6')" />
          </p>

          <!-- Step 8 -->
          <p class="text">
            {{ $t("gps.chrome-step-8") }}
          </p>

          <!-- close button -->
          <p class="has-text-centered">
            <a class="button is-link" @click="closeModal">{{ $t("close") }}</a>
          </p>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChromeGPSModal",
  methods: {
    closeModal() {
      this.$el.querySelector(".modal").classList.remove("is-active");
    },
    openChromeBrowser() {
      // window.location = "https://tukapp.co";
      // window.open("", "_blank", "toolbar=0,location=0,menubar=0");
      window.open("", "_blank");
    },
  },
};
</script>

<style scoped>
.header {
  font-size: 1.3em;
  font-weight: 550;
  margin-bottom: 16px;
  color: grey;
}
.text {
  font-size: 1.2em;
  font-weight: 450;
  margin-bottom: 10px;
  text-align: left;
  color: var(--success);
}
.img-wrapper {
  text-align: center;
  margin-bottom: 16px;
}
img {
  box-shadow: 0px 0px 5px rgb(221, 221, 221);
  border-radius: 4px;
}
</style>